/* ==========================================================================
   ZZ MARTS — STICKY OFFSET MEASURER
   Publishes --zz-sticky-top on <html>: the exact y where a pinned element
   must sit so it lands flush under the sticky header.

   WHY THIS EXISTS
   The collection filter bar was hard-coded to top: 66px. That number came from
   one measurement on one window, and it is not stable:
     - Horizon pins the header with position:sticky, top:-1px, so the header
       bottom is 65px, not 66px.
     - Header height changes with logo size, whether the announcement bar is in
       the sticky group, and the theme editor's own preview chrome.
     - --header-height is NOT set on :root on this theme. Reading it returns an
       empty string and every consumer silently falls back.
   A wrong offset shows up as the bar sitting a few pixels low with page content
   sliding through the gap above it, which reads as "the bar still moves".

   HOW IT MEASURES
   The sticky element is NOT <header-component> — that is position:static. It is
   the ancestor <header class="shopify-section-group-header-group">, which
   carries position:sticky and top:-1px. So the pinned bottom edge is:
       stickyTop + height        e.g. -1 + 66 = 65
   No scroll listener: the value only changes on resize or a theme-editor
   re-render, so it is computed then and left alone. A scroll listener here
   would rewrite `top` on a sticky element mid-scroll and make it jitter.

   If no sticky ancestor is found the offset is 0, which is correct — a header
   that scrolls away should not reserve space.
   ========================================================================== */
(function () {
  'use strict';

  var FALLBACK = 64;

  function stickyAncestor(el) {
    var n = el;
    while (n && n !== document.documentElement) {
      var pos = getComputedStyle(n).position;
      if (pos === 'sticky' || pos === 'fixed') return n;
      n = n.parentElement;
    }
    return null;
  }

  function measure() {
    var header = document.querySelector('header-component, .header, header.shopify-section-group-header-group');
    if (!header) return;

    var pinned = stickyAncestor(header);
    var offset = 0;

    if (pinned) {
      var cs = getComputedStyle(pinned);
      var top = parseFloat(cs.top);
      if (isNaN(top)) top = 0;
      offset = top + pinned.getBoundingClientRect().height;
      if (!isFinite(offset) || offset < 0) offset = 0;
    }

    document.documentElement.style.setProperty('--zz-sticky-top', Math.round(offset) + 'px');
  }

  function schedule() {
    requestAnimationFrame(measure);
  }

  document.documentElement.style.setProperty('--zz-sticky-top', FALLBACK + 'px');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);

  /* Theme editor swaps sections in and out without a page load. */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
})();
